import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { currentUserActions } from "store/currentUser/currentUserSlice";
import { useQuery } from "lib/apollo/client";
import {
  GetNotificationCountType,
  getNotificationsCount,
} from "queries/users/getNotificationsCount";
import useCurrentUserId from "hooks/user/useCurrentUserId";

const POLL_INTERVAL = 1000 * 60 * 5; // Every 5 minutes

export default function NotificationsUpdater() {
  const dispatch = useDispatch();
  const userId = useCurrentUserId()

  const { data, startPolling } = useQuery<GetNotificationCountType>(getNotificationsCount, {
    variables: {
      userId,
    },
    fetchPolicy: "no-cache",
    skip: !userId,
    pollInterval: POLL_INTERVAL,
  });

  useEffect(() => {
    setTimeout(() => {
      startPolling(POLL_INTERVAL);
    }, POLL_INTERVAL);
  }, []);

  useEffect(() => {
    if (data) {
      dispatch(
        currentUserActions.setNotificationsCount(
          data.notifications.aggregate.count
        )
      );
    }
  }, [data]);

  return false;
}
